<template>
  <el-row class="content-header">
    <el-col :span="24">
      <div class="title">
        <i v-if="includeBack" class="el-icon-arrow-left c-highlight pointer fs-20" @click="back" />
        {{ title }}
      </div>
      <div class="sub-title" v-if="subTitle">
        {{ subTitle }}
      </div>
    </el-col>
    <el-col v-if="!noDivider" :span="24">
      <el-divider />
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ContentHeader',
  props: {
    title: String,
    subTitle: String,
    backTo: String,
    includeBack: Boolean,
    noDivider: Boolean
  },
  methods: {
    back() {
      if (this.backTo) this.$router.push(this.backTo);
      else this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.content-header {
  margin-bottom: 1em;
  // max-width: 768px !important;

  .title {
    font-size: 1.5em;
    font-weight: 500;
    margin-top: 0.8em;
    margin-bottom: 0.5em;
  }

  .sub-title {
    font-size: 0.85em;
    // color: $color-text-primary;
    margin-bottom: 1em;
    font-family: $fontLight;
    line-height: 1.25em;
  }
}
</style>
